<template>
    <div id="tenants-avatar" class="d-flex justify-content-center">
        <div class="label-tenant fs-14" :class="{'disabled': disabled}" :style="'--tenant-color:' + tenantColor" v-if="tenantImage === null">
            <model-short-name v-bind:model="tenant"></model-short-name>
        </div>
        <img class="tenant-img img-fluid" v-else :src="tenantImage" alt="">
    </div>
</template>
<script>

// Internal components
import ModelShortName from './ModelShortName.vue';

// Helpers
import { EventBus } from '@/helpers/EventBus.js';

export default {
    props: ['tenant', 'disabled'],

    components: {
        ModelShortName
    },

    data () {
        return {
            tenantColor: '',
            tenantImage: null
        };
    },

    mounted () {
        // Set color for tenant when no image represent the tenant avatar
        this.tenantColor = this.tenant.attributes['default-color'] || '#FFDEEB';

        this.tenantImage = this.tenant.attributes['profile-picture'];

        // Listen for tenant image update
        EventBus.$on('tenant-image-updated', this.refreshImage);
    },

    beforeDestroy () {
        EventBus.$off('tenant-image-updated', this.refreshImage);
    },

    methods: {
        /**
         * Refresh the displayed image, using a timestamp to bypass the browser cache
         */
        refreshImage () {
            this.tenantImage = this.tenant.attributes['profile-picture'] !== null ? `${this.tenant.attributes['profile-picture']}?${Date.now()}` : null;
        }
    }
};
</script>
